<div class="border rounded position-relative bg-light overflow-hidden d-flex align-items-center justify-content-center" [style.height]="large ? '75vh' : '180px'">
  <div *ngIf="isLoading" class="position-absolute d-flex align-items-center justify-content-center" style="inset: 0; z-index: 3; background: rgba(255,255,255,0.6)">
    <i class="la la-spin la-cog la-lg text-muted"></i>
  </div>

  <ng-container *ngIf="images.length && !isLoading">
    <img [src]="current.image_url" [alt]="current.original_file_name" style="max-width: 100%; max-height: 100%; object-fit: contain;">

    <!-- Left Button -->
    <button type="button" class="btn btn-dark btn-sm rounded-circle" style="position: absolute; top: 50%; left: 8px; transform: translateY(-50%); opacity: 0.7; z-index: 2;" (click)="shift(-1)" *ngIf="images.length > 1">
      <i class="la la-chevron-left"></i>
    </button>

    <!-- Right Button -->
    <button type="button" class="btn btn-dark btn-sm rounded-circle" style="position: absolute; top: 50%; right: 8px; transform: translateY(-50%); opacity: 0.7; z-index: 2;" (click)="shift(1)" *ngIf="images.length > 1">
      <i class="la la-chevron-right"></i>
    </button>

    <!-- Delete Button -->
    <button *ngIf="editable" type="button" class="position-absolute btn btn-danger btn-sm rounded-circle" style="top: 8px; left: 8px; z-index: 2;" (click)="deleteImage(current)" [disabled]="isDeleting(current.id)">
      <i *ngIf="!isDeleting(current.id)" class="la la-trash"></i>
      <i *ngIf="isDeleting(current.id)" class="la la-spin la-cog"></i>
    </button>

    <!-- Open in New Tab Button -->
    <a [href]="current.image_url" target="_blank" rel="noopener noreferrer" class="position-absolute btn btn-primary btn-sm rounded-circle" style="top: 8px; right: 8px; z-index: 2;">
      <i class="la la-external-link-alt"></i>
    </a>

    <!-- Slide indicator, e.g. "1 / 4" -->
    <span class="position-absolute badge badge-dark" style="bottom: 8px; right: 8px; opacity: 0.8; z-index: 2;">
      {{ index + 1 }} / {{ images.length }}
    </span>
  </ng-container>

  <ng-container *ngIf="!images.length && !isLoading">
    <div class="text-muted d-flex flex-column align-items-center">
      <i class="la la-image la-3x mb-2"></i>
      <span>No images</span>
    </div>
  </ng-container>
</div>
